import { create } from 'zustand'
import { STANDAARD_SCENE, metProfiel } from '../scene/config'
import type { Profiel, SceneConfig } from '../scene/config'

/**
 * De film van de zweefronde (22 oktober): de hal op het hoofdscherm, offline
 * gerenderd met Remotion uit dezelfde scène (`remotion/`, docs/zweeffilm.md).
 * Hij staat in de R2-bucket, zoals de films van Marketing; staat hij er niet,
 * dan antwoordt de Worker 404 en blijft het hoofdscherm realtime.
 */
export const ZWEEFFILM = '/video/zweefronde.mp4'

/** De film is 16:9; op een ander scherm valt hij niet over de hal heen. */
export const FILM_VERHOUDING = 16 / 9

interface ZweeffilmState {
  /**
   * Of de hal stilstaat omdat de film hem bedekt: het canvas tekent dan niet
   * (`frameloop="never"` in App.tsx). Als prop op het canvas en niet via
   * `setFrameloop`, want het canvas zet bij elke rerender zijn eigen props terug.
   */
  halStil: boolean
  zetHalStil: (v: boolean) => void
}

export const useZweeffilm = create<ZweeffilmState>((set) => ({
  halStil: false,
  zetHalStil: (halStil) => set({ halStil }),
}))

/**
 * Of de hal er nu uitziet zoals in de film: de standaardscène van dit profiel,
 * met de Matics als Linde-beeld (`linde`: de schakelaar of `?linde=`). Wie in
 * de Studio iets verschuift, ziet de realtime hal; de schakelaars van de film
 * en van het Linde-beeld zelf tellen in de vergelijking niet mee.
 */
export function halZoalsFilm(scene: SceneConfig, profiel: Profiel, linde: boolean): boolean {
  const zonder = (s: SceneConfig) => ({ ...s, objecten: { ...s.objecten, zweeffilm: true, lindeBeeld: true } })
  return linde && gelijk(zonder(scene), zonder(metProfiel(STANDAARD_SCENE, profiel)))
}

/** Diep gelijk, los van de volgorde van de sleutels. */
function gelijk(a: unknown, b: unknown): boolean {
  if (a === b) return true
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false
  const ka = Object.keys(a)
  if (ka.length !== Object.keys(b).length) return false
  return ka.every((k) => gelijk((a as Record<string, unknown>)[k], (b as Record<string, unknown>)[k]))
}
